const TagsFilter = ({ name, onClick, selectedName }) => {
    const selected = selectedName === name;
    const handleClick = () => onClick(name);

    return (
        <button onClick={handleClick} className={`tag-item ${selected ? 'selected' : ''}`}>
            {name}
        </button>
    );
};

export default TagsFilter;
